import { Skeleton } from "antd";
import useRainforestComponents from "./useRainforestComponents";
import { RainforestSession } from "../../domain/invoicing/rainforest";

declare module "react/jsx-runtime" {
  namespace JSX {
    interface IntrinsicElements {
      "rainforest-deposit-report": any;
    }
  }
}

type Props = {
  rainforestSession: RainforestSession
}

const DepositReport = ({rainforestSession}: Props) => {
  const loadingStatus = useRainforestComponents(rainforestSession)
  if (loadingStatus !== 'READY') {
    return <Skeleton active />
  }

  return <rainforest-deposit-report
    session-key={rainforestSession.sessionKey}
    data-filters={`{"merchant_id":"${rainforestSession.merchantId}"}`}
    display-records='50'
    show-record-count-selector
    show-export-button
    show-chargeback-respond-button
    style-button-color="#FF5C35"
  ></rainforest-deposit-report>
}

export default DepositReport